import React, {useEffect} from "react";
import SubTitle from "../../components/SubTitle";
import {useForm, FormProvider, SubmitHandler} from "react-hook-form";
import {useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem, ResponseList} from "../../models/clientModels/interfaces/Response";
import {useNavigate, useParams} from "react-router-dom";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import * as boardApi from "../../api/boardApi/boardApi";

import {useQuery, useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import MWProgress from "../../components/MWProgress";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {KPBoard, initializeBoard} from "../../models/serverModels/board/KPBoard";
import BoardForm from "./BoardForm";

const UpdateBoard = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data: boardList, isLoading: isGetLoading} = useQuery(
    ["BoardItem", {token: tokenState, id: parseInt(id!)}],
    () => boardApi.getItem({token: tokenState, id: parseInt(id!)})
  );

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<KPBoard>,
    Params.Update<KPBoard>
  >({
    api: boardApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate("/Board");
        queryClient.invalidateQueries("BoardList");
      },
    },
  });

  const methods = useForm<KPBoard>({
    defaultValues: boardList?.item || initializeBoard(),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(boardList?.item);
  }, [boardList?.item, reset]);

  const onSubmit: SubmitHandler<KPBoard> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...initializeBoard(), ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="게시판 수정" />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <BoardForm captionColor="#546E7A" />
            <ConfirmButtonGroup link="/Board" cancelText="취소" confirmText="수정" />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateBoard;
